$('.MenuBtn').click(function(){
    $('.responsiveHeader').addClass('active')
})
$('.RescrsBtn').click(function(){
    $('.responsiveHeader').removeClass('active')
})
$('.bannerSlider').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    dotsClass: 'custom-slick-dots',
    appendDots: $('.slider-dots'),
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});
$('.cartinnerSlider').slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 300,
    fade: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});
$('.logoSider').slick({
    arrows: false,
    dots: false,
    infinite: true,
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});
$('.testiislider').slick({
    arrows: false,
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});




const cursor = document.getElementById("cursorImg");

// follow cursor
document.addEventListener("mousemove", (e) => {
    cursor.style.top = e.clientY + "px";
    cursor.style.left = e.clientX + "px";
});

// click animation
document.addEventListener("click", () => {
    cursor.classList.add("click-scale");

    setTimeout(() => {
        cursor.classList.remove("click-scale");
    }, 200);
});


document.querySelectorAll('.main_rooted').forEach(card => {
    const para = card.querySelector('p');
    const text = para.getAttribute('data-text');
    let typingInterval;

    function startTyping() {
        let i = 0;

        clearInterval(typingInterval);
        para.innerHTML = "";
        para.style.opacity = "1";

        typingInterval = setInterval(() => {
            if (i < text.length) {
                para.innerHTML += text.charAt(i);
                i++;
            } else {
                clearInterval(typingInterval);
            }
        }, 25);
    }

    function resetTyping() {
        clearInterval(typingInterval);
        para.innerHTML = "";
        para.style.opacity = "0";
    }

    // Desktop only
    if (window.innerWidth > 767) {
        card.addEventListener('mouseenter', startTyping);
        card.addEventListener('mouseleave', resetTyping);
    }

    // Mobile only
    if (window.innerWidth <= 767) {
        card.addEventListener('click', function () {

            document.querySelectorAll('.main_rooted p').forEach(otherPara => {
                if (otherPara !== para) {
                    otherPara.innerHTML = "";
                    otherPara.style.opacity = "0";
                }
            });

            if (para.style.opacity === "1") {
                resetTyping();
            } else {
                startTyping();
            }
        });
    }
});

const header = document.querySelector('.header');
let isHovering = false;

function updateHeaderState() {
    if ($(window).scrollTop() > 50 || isHovering) {
        header.classList.add('active');
    } else {
        header.classList.remove('active');
    }
}

// Scroll
$(window).on('scroll', function() {
    updateHeaderState();
});

// Hover
document.querySelectorAll('.headLinks').forEach(link => {
    link.addEventListener('mouseenter', () => {
        isHovering = true;
        updateHeaderState();
    });

    link.addEventListener('mouseleave', () => {
        isHovering = false;
        updateHeaderState();
    });
});


// blog 01
  // Intersection Observer for scroll animations
  const items = document.querySelectorAll('.ritual-item');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        setTimeout(() => entry.target.classList.add('visible'), i * 100);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  items.forEach(item => observer.observe(item));


  const steps = document.querySelectorAll('.journey-step');
  const obs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.15 });
  steps.forEach(s => obs.observe(s));